module.exports = __webpack_public_path__ + "img/bornutti10.72276ce8.jpg";